export enum REPORT_TYPES {
    LOGIC_TEST_REPORT = 'LOGIC_TEST_REPORT',
    PERSONALITY_TEST_REPORT = 'PERSONALITY_TEST_REPORT',
    BACKGROUND_INFORMATION_REPORT = 'BACKGROUND_INFORMATION_REPORT',
    LEADERSHIP_REPORT = 'LEADERSHIP_REPORT'
}
